module.exports = __webpack_public_path__ + "img/background.2d2cc44c.png";